// language=GraphQL
export const ALL_GRID_BLOCK_COLUMNS_QUERY = `query Query($withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  gridBlockColumns: cmsGridBlockColumns {
    id
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          phone
          email

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_GRID_BLOCK_COLUMN_QUERY = `query Query($id: ID!, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  gridBlockColumn: cmsGridBlockColumn(id: $id) {
    id
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          phone
          email

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_GRID_BLOCK_COLUMN_MUTATION = `
  mutation Mutation($input: CreateCmsGridBlockColumnInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    gridBlockColumn: createCmsGridBlockColumn(input: $input) {
      id
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_GRID_BLOCK_COLUMN_MUTATION = `
  mutation Mutation($input: UpdateCmsGridBlockColumnInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    gridBlockColumn: updateCmsGridBlockColumn(input: $input) {
      id
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_GRID_BLOCK_COLUMN_MUTATION = `
  mutation Mutation($input: DeleteCmsGridBlockColumnInput) {
    deleteCmsGridBlockColumn(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION = `
  mutation Mutation($input: DeleteCmsGridBlockColumnInput) {
    forceDeleteCmsGridBlockColumn(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: addCmsGridBlockColumnContentBlockAssignmentsInput) {
    addCmsGridBlockColumnContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const REMOVE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: removeCmsGridBlockColumnContentBlockAssignmentsInput) {
    removeCmsGridBlockColumnContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const CREATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: createCmsGridBlockColumnContentBlockAssignmentsInput) {
    createCmsGridBlockColumnContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const DELETE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: deleteCmsGridBlockColumnContentBlockAssignmentsInput) {
    deleteCmsGridBlockColumnContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const UPDATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsGridBlockColumnContentBlockAssignmentsOrderInput) {
    updateCmsGridBlockColumnContentBlockAssignmentsOrder(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const GRID_BLOCK_COLUMNS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsGridBlocks: Boolean = false) {
  groupedDependents: cmsGridBlockColumnDependents(id: $id) {
    cmsGridBlocks @include(if: $withCmsGridBlocks) {
      id
    }
  }
}`
